import { render } from "./YoungPersonProfile.vue?vue&type=template&id=1b724ec2&scoped=true"
import script from "./YoungPersonProfile.vue?vue&type=script&lang=js"
export * from "./YoungPersonProfile.vue?vue&type=script&lang=js"

import "./YoungPersonProfile.vue?vue&type=style&index=0&id=1b724ec2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b724ec2"]])

export default __exports__